import controller from './tableGridTextCell.controller';
import _ from 'lodash';

let tableGridTextCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns: '='
    },
    template : '<a ng-bind-html="vm.cellValue"></a>',
    controller,
    controllerAs: 'vm',
    link: (scope, elem, attrs, ctrl) => {
      scope.column = _.find(scope.columns, {
        name: scope.columnName
      });

      scope.vm = scope;
      scope.vm.cellValue = ctrl.getCellValue(scope.row, scope.column);
    }
  };
};

export
default tableGridTextCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridTextCell/tableGridTextCell.component.js